import {
    ADDUPDATEKYCCONF_SUCCESS,
    ADDUPDATEKYCCONF_FAILED,
    RESET_ADDUPDATEKYCCONF,
    LOADING_ADDUPDATEKYCCONF,
    NETWORK_ERROR_ADDUPDATEKYCCONF,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddUpdateKycConf = () => {
    return { type: RESET_ADDUPDATEKYCCONF };
};

const addUpdateKycConf = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDUPDATEKYCCONF });
    await partnerServices
        .post("getAddEditKycConfig", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(addUpdateKycConfsuccess(res.data));
                    break;
                default:
                    dispatch(addUpdateKycConfFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_ADDUPDATEKYCCONF, payload: err });
        });
};
function addUpdateKycConfsuccess(data) {
    return {
        type: ADDUPDATEKYCCONF_SUCCESS,
        payload: data,
    };
}
function addUpdateKycConfFailed(data) {
    return {
        type: ADDUPDATEKYCCONF_FAILED,
        payload: data,
    };
}

export { resetAddUpdateKycConf, addUpdateKycConf };
